import o from "./ghl-ui.es1202.js";
import e from "./ghl-ui.es1203.js";
import t from "./ghl-ui.es1199.js";
import m from "./ghl-ui.es1201.js";
function s(r) {
  return t(r) ? o(m(r)) : e(r);
}
export {
  s as default
};
